import React, { Component } from 'react'
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import classes from './VideoPlayerControls.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStepForward, faStepBackward } from '@fortawesome/free-solid-svg-icons';

import PH from 'Flow2/util/MetadataPermissionHelper.js';
import * as Controls from 'Flow2/config/Controls';


const mapStateToProps = (state, ownProps) => {
	return {
		config: state.ui.config
	}
}

const mapDispatchToProps = (dispatch) => {
	return {}
}

const forward = (props) => {
		if(!PH.showControl(props.config, Controls.CTL_PLAYER_FRAME_FORWARD)) return "";
		
		const frameStep = (props.mediafile && props.mediafile.fps) ? (1 / props.mediafile.fps) : 0;
		
		const onFrameForward = () => {
			const currentTime = props.video.currentTime;
			props.video.currentTime = currentTime + frameStep;
		}
		
		return (
			<div className={[classes.FrameForward, classes.Icon, 'pointer'].join(' ')} >
				<FontAwesomeIcon onClick={onFrameForward} icon={faStepForward} title={props.intl.formatMessage({ id: "videoplayer.frame.forward" })} />
			</div>
		);
	}
	
export const FrameForward = connect(mapStateToProps, mapDispatchToProps)(injectIntl(forward));

const backward = (props) => {
		if(!PH.showControl(props.config, Controls.CTL_PLAYER_FRAME_BACKWARD)) return "";
		
		const frameStep = (props.mediafile && props.mediafile.fps) ? (1 / props.mediafile.fps) : 0;
		
		const onFrameBackward = () => {
			if (props.video.currentTime > 0) {
				const currentTime = props.video.currentTime;
				props.video.currentTime = currentTime - frameStep;
			}
		}
		
		return (
			<div className={[classes.FrameBackward, classes.Icon, 'pointer'].join(' ')} >
				<FontAwesomeIcon onClick={onFrameBackward} icon={faStepBackward} title={props.intl.formatMessage({ id: "videoplayer.frame.backward" })} />
			</div>
		);
	}

export const FrameBackward = connect(mapStateToProps, mapDispatchToProps)(injectIntl(backward));
